import styled from '@emotion/styled';

import { getContrastFontColor } from '../../util/getContrastFontColor';
import { Image } from '../Image/Image';

const componentConfig = {
  headerHeight: 65,
};

const Container = styled.header(({ theme }) => ({
  position: 'fixed',
  zIndex: 100,
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.stellenportal?.headerStyle?.color || theme.eclipseTier2Color.surface.raised,
  color: theme.stellenportal?.headerStyle?.color
    ? getContrastFontColor(theme.stellenportal?.headerStyle?.color)
    : theme.eclipseTier2Color.surface.raised,
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.eclipseTier1.spacing['12px'],
  overflow: 'hidden',
  height: componentConfig.headerHeight,
}));

const Row = styled.div(({ theme }) => ({
  backgroundColor: theme.stellenportal?.headerStyle?.color || theme.eclipseTier2Color.surface.raised,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `0 ${theme.eclipseTier1.spacing['16px']}`,
  zIndex: 100,
  height: '100%',
}));

const Logo = styled(Image)({
  maxHeight: 40,
  maxWidth: 220,
});

const SecondRow = styled(Row)(({ theme }) => ({
  position: 'fixed',
  left: 0,
  right: 0,
  padding: `${theme.eclipseTier1.spacing['12px']} ${theme.eclipseTier1.spacing['32px']}`,
  transition: 'all 0.3s ease-in',
  zIndex: 99,
  height: 'unset',
}));

const JobDetails = styled.div(({ theme }) => ({
  display: 'flex',
  '& > *:not(:last-child)': {
    '::after': {
      content: '"·"',
      margin: `0 ${theme.eclipseTier1.spacing['8px']}`,
    },
  },
}));

const ActionButtons = styled.div(({ theme }) => ({
  display: 'flex',
  columnGap: theme.eclipseTier1.spacing['8px'],
  '& button': {
    color: 'inherit',
  },
}));

export const S = {
  componentConfig,
  Container,
  Row,
  Logo,
  SecondRow,
  JobDetails,
  ActionButtons,
} as const;
